<script lang="ts" setup>
const { loggedIn, clear } = useUserSession()

watchEffect(() => {
  console.log('Logout ::', loggedIn.value)
})
</script>

<template>
  <div
    v-if="loggedIn"
    class="fixed top-4 right-4"
  >
    <UButton
      variant="outline"
      icon="i-line-md-logout"
      :ui="{ rounded: 'rounded-full' }"
      @click="async () => { await clear(); $router.push('/') }"
    >
      Logout
    </UButton>
  </div>
</template>

<style>

</style>
